import { render } from "./VectorLayers.vue?vue&type=template&id=0ad09f1c"
import script from "./VectorLayers.vue?vue&type=script&lang=js"
export * from "./VectorLayers.vue?vue&type=script&lang=js"
script.render = render

export default script